import { TConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';

import { DashboardConfiguration } from '../../apps/dashboard/types/DashboardTypes';

/**
 * Check if the new dashboard feature is enabled
 */
export const isDashboardEnabled = (configuration: TConfiguration | null): boolean => {
	return configuration?.PLATFORM?.DEV_TOGGLES?.ENABLE_NEW_PLATFORM_DASHBOARD === true;
};

/**
 * @public
 * NOTE: Remove this comment once the function is actually used.
 */
export const isWebSdksBulkEditEnabled = (configuration: TConfiguration | null): boolean => {
	return configuration?.PLATFORM?.DEV_TOGGLES?.ENABLE_WEB_SDKS_BULK_EDIT === true;
};

/**
 * Get dashboard configuration safely with proper typing
 */
export const getDashboardConfig = (configuration: TConfiguration): DashboardConfiguration => {
	return {
		PLATFORM: {
			DEV_TOGGLES: {
				ENABLE_NEW_PLATFORM_DASHBOARD:
					configuration.PLATFORM?.DEV_TOGGLES?.ENABLE_NEW_PLATFORM_DASHBOARD === true
			}
		}
	};
};

/**
 * Check if configuration is ready and available
 */
export const isConfigurationReady = (
	configuration: TConfiguration | null
): configuration is TConfiguration => {
	return configuration !== null && configuration !== undefined;
};
